var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar_header"},[(this.scheduleNextWeek && this.scheduleNextWeek.date)?[_c('DateTraveller'),_c('DaysTraveller')]:_vm._e(),_c('BranchFilter')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }